<template>
  <b-modal
      id="modal_form"
      ref="modal_form"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      cancel-title="Cancelar"
      :ok-disabled=form.errors.any()
      v-model="showModal"
      @ok="handleOk">

    <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
      <label>Código</label>
      <b-form-input type="text"
                    placeholder="Código"
                    v-model="form.cd"
                    name="cd"
      >
      </b-form-input>
      <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

      <label>Descrição</label>
      <b-form-input type="text"
                    placeholder="Descrição"
                    v-model="form.descr"
                    name="descr"
      >
      </b-form-input>
      <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

      <label>Status</label>
      <multiselect v-model="statusSelected"
                   :options="this.$parent.optionsLivStatus"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>

      <label>Tipo de processo</label>
      <multiselect v-model="tpProcessoSelected"
                   :options="this.$parent.optionsLivtpProcesso"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('tp_processo')" v-if="form.errors.has('tp_processo')"></b-form-feedback>

      <label>Transportador = Uf origem </label>
      <multiselect v-model="transportadoraUfSelected"
                   :options="this.$parent.optionsLivtrasnpotadoraUf"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('transportadora_uf')" v-if="form.errors.has('transportadora_uf')"></b-form-feedback>

      <label>Categoria</label>
      <multiselect v-model="categoriaCfopSelected"
                   :options="this.$parent.optionsLivcategoriaCfop"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('parcatcfo_id')" v-if="form.errors.has('parcatcfo_id')"></b-form-feedback>

      <label>CFOP Municipal</label>
      <multiselect v-model="cfopMunicipalSelected"
                   :options="this.$parent.optionsLivCfop"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('cfop_id_municipal')" v-if="form.errors.has('cfop_id_municipal')"></b-form-feedback>

      <label>CFOP Estadual</label>
      <multiselect v-model="cfopEstadualSelected"
                   :options="this.$parent.optionsLivCfop"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('cfop_id_estadual')" v-if="form.errors.has('cfop_id_estadual')"></b-form-feedback>

      <label>CFOP Interestadual</label>
      <multiselect v-model="cfopInterestadualSelected"
                   :options="this.$parent.optionsLivCfop"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('cfop_id_interestadual')" v-if="form.errors.has('cfop_id_interestadual')"></b-form-feedback>

      <label>CFOP Exterior</label>
      <multiselect v-model="cfopExteriorSelected"
                   :options="this.$parent.optionsLivCfop"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
      ></multiselect>
      <b-form-feedback v-text="form.errors.get('cfop_id_exterior')" v-if="form.errors.has('cfop_id_exterior')"></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
      <div class="float-right">
        <b-btn @click="showModal=false" variant="secondary">
          Fechar
        </b-btn>
        <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>

</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      showModalNaturezaAliquota: false,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivtpProcesso: [],
      optionsLivtrasnpotadoraUf: [],
      optionsLivcategoriaCfop: [],
      optionsLivCfop: [],
      transportadoraUfSelected: [],
      tpProcessoSelected: [],
      categoriaCfopSelected: [],
      optionsLivStatus: [],
      statusSelected: [],
      cfopEstadualSelected: [],
      cfopInterestadualSelected: [],
      cfopExteriorSelected: [],
      cfopMunicipalSelected: [],
      optionsLivStatusAliquota: [],
      form: new Form({
        cd: '',
        descr: '',
        cforeg_id: '',
        status: '',
        tp_processo:'',
        transportadora_uf:'',
        parcatcfo_id:'',
        cfop_id_estadual:'',
        cfop_id_interestadual:'',
        cfop_id_exterior:'',
        cfop_id_municipal:'',
      }),
      helpForm: new Form({
        recordCollection: [],
        params: []
      }),
      css: {
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
    }
  },
  watch: {
    statusSelected(obj){
      this.form.status = obj.value;
    },
    tpProcessoSelected(obj){
      this.form.tp_processo = obj.value;
    },
    categoriaCfopSelected(obj){
      this.form.parcatcfo_id = obj.value;
    },
    transportadoraUfSelected(obj){
      this.form.transportadora_uf = obj.value;
    },
    cfopEstadualSelected(obj){
      this.form.cfop_id_estadual = obj.value;
    },
    cfopInterestadualSelected(obj){
      this.form.cfop_id_interestadual = obj.value;
    },
    cfopExteriorSelected(obj){
      this.form.cfop_id_exterior = obj.value;
    },
    cfopMunicipalSelected(obj){
      this.form.cfop_id_municipal = obj.value;
    },
  },
  mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
  },
  created() {
    let self = this;
    Event.$on('reloadVuetable', function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        'cd': data_filter.cd,
        'descr': data_filter.descr,
        'status': data_filter.status.value
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      })
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit('setVuetableFilterRow', false);
      } else {
        this.$store.commit('setVuetableFilterRow', true);
      }
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cfop_id);
    },

    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.cforeg_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.cfopEstadualSelected = [];
      this.cfopInterestadualSelected = [];
      this.cfopExteriorSelected = [];
      this.cfopMunicipalSelected = [];
      this.transportadoraUfSelected = [];
      this.categoriaCfopSelected = [];
      this.tpProcessoSelected = [];
      this.statusSelected  = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.cd = data.cd;
      this.optionsLivtpProcesso = [];
      this.optionsLivtrasnpotadoraUf = [];
      this.optionsLivcategoriaCfop = [];
      this.optionsLivCfop = [];
      this.transportadoraUfSelected = [];
      this.tpProcessoSelected = [];
      this.categoriaCfopSelected = [];
      this.optionsLivStatus = [];
      this.statusSelected = [];
      this.cfopEstadualSelected = [];
      this.cfopInterestadualSelected = [];
      this.cfopExteriorSelected = [];
      this.cfopMunicipalSelected = [];
      this.form.descr = data.descr;
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      if(data.tp_processo != null) {

        this.tpProcessoSelected = {
          label: data.tp_processo.descr,
          value: data.tp_processo.valor
        }
      }
      this.categoriaCfopSelected = {
        label: data.param_categoria_cfop.descr,
        value: data.param_categoria_cfop.parcatcfo_id
      }
      this.transportadoraUfSelected = {
        label: data.transportadora_uf.descr,
        value: data.transportadora_uf.valor
      }
      this.cfopMunicipalSelected = {
        label: data.cfop_municipal.cd + "-" + data.cfop_municipal.descr,
        value: data.cfop_municipal.cfop_id

      }
      this.cfopExteriorSelected = {
        label: data.cfop_exterior.cd + "-" + data.cfop_exterior.descr,
        value: data.cfop_exterior.cfop_id
      }
      this.cfopInterestadualSelected = {
        label: data.cfop_interestadual.cd + "-" + data.cfop_interestadual.descr,
        value: data.cfop_interestadual.cfop_id
      }
      this.cfopEstadualSelected = {
        label: data.cfop_estadual.cd + "-" + data.cfop_estadual.descr,
        value: data.cfop_estadual.cfop_id
      }
      this.form.cforeg_id = data.cforeg_id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.post('/api/cfopregra/store').then(response => {
        new ReturnApi(response, this)
      })
          .catch(errors => {
            new ReturnApi(errors, this)
          });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.patch('/api/cfopregra/update/' + id).then(response => {
        new ReturnApi(response, this)
      })
          .catch(errors => {
            new ReturnApi(errors, this)
          });
    },
    onActivateDesactivate(helpForm)
    {
      helpForm.patch('/api/cfopregra/status').then(response =>
      {
        new ReturnApi(response, this)
        if(this.metodo!=null)
        {
          this.$parent.$refs.vuetable.reload();
        }
      })
          .catch(errors =>
          {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
          });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
}
</script>
